module.exports = "<i class=\"spark-icon spark-icon-close unchecked\"></i>";